import React from 'react';
import WorkHistory from '../components/WorkHistory';

const WorkPage = () => {
  return (
    <div>
      <WorkHistory />
    </div>
  );
};

export default WorkPage;


